import { Subscription } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';

import { GlobalService } from './global.service';
import { Subject } from 'rxjs/Subject';
import { ssApiService } from './ss-api.service';
import { PinArray, PinItem, PinTypes } from '../models/domain/pin';
import { PinAddRequest } from '../models/ss-api/requests/pin.add.request';

@Injectable()
export class PinService implements OnDestroy {

    public onPinsLoaded = new Subject<PinArray>();
    public onPinAdded = new Subject<PinItem>();
    public onPinRemoved = new Subject<PinItem>();
    public onPinsChanged = new Subject();

    public Pins = new PinArray();

    // subscriptions
    private SubPinsLoaded: Subscription;
    private SubPinDeleted: Subscription;
    private SubPinAdded: Subscription;

    constructor(private api: ssApiService, private gb: GlobalService) {
        this.SubcribeToEvents();
    }

    Refresh() {
        let subscription = this.api.getPins(this.gb.AdminId).subscribe(

            (response) => {
                subscription.unsubscribe();
                // console.log("pins received", response);
                if (response.Result)
                    this.onPinsLoaded.next(response.Data);
                this.onPinsChanged.next();
            }

        );

    }

    Add(pin: PinAddRequest) {

        // we use this over the ssdb2 so that we can check if the item already exists
        if (this.Pins == null || this.Pins.length == 0) {
            this.api.PinAdd(pin).subscribe();
            return;
        }

        // we cannot use find or findindex because we can get duplicated (not stable)
        for (let i = 0; i < this.Pins.length; i++) {
            let thisPin = this.Pins[i];
            if (thisPin.RelationID == pin.RelationID && thisPin.PinType == pin.PinType) {
                // already exists
                // console.log("creation of pin ignored because already exist");
                this.Refresh();
                return;
            }
        }

        // we didnt find the pin, so add
        this.api.PinAdd(pin).subscribe();
    }

    DeletePinByType(id: number, pinType: PinTypes) {

        let index: number = this.Pins.findIndex(x => x.RelationID == id && x.PinType == pinType);
        if (index > -1) {
            this.api.PinDelete(this.Pins[index].ID).subscribe();
        } else {
            // we didn't find the pin
            this.Refresh();
        }

    }


    IsPinned(id: number, pinType: PinTypes): boolean {

        let index: number = this.Pins.findIndex(x => x.RelationID == id && x.PinType == pinType);
        if (index > -1) {
            return true;
        } else {
            return false;
        }

    }

    private SetPins(pins: PinArray) {
        this.Pins = pins;
        this.onPinsLoaded.next(pins);
        this.onPinsChanged.next();
    }

    SubcribeToEvents() {

        // loaded
        this.SubPinsLoaded = this.api.onGetPins.subscribe(
            (response) => {

                if (!response.Result)
                    return;

                this.SetPins(response.Data);

            }
        )

        // deleted
        this.SubPinDeleted = this.api.onPinDelete.subscribe(
            (response) => {

                if (!response.Result) {
                    this.Refresh()
                    return;
                }

                // delete from array
                // we cannot use find or findindex because it is not stable
                for (let i = 0; i < this.Pins.length; i++) {

                    let thisPin = this.Pins[i];

                    if (thisPin.ID == response.Data) {

                        // remove from list and fire event
                        this.Pins.splice(i, 1);
                        this.onPinRemoved.next(thisPin);
                        this.onPinsChanged.next();
                    }
                }
            }
        )

        // added
        this.SubPinAdded = this.api.onPinAdd.subscribe(
            (response) => {

                // console.log("pin add response", response);
                if (!response.Result)
                    return;

                // console.log("adding pin to array", response.Data);

                this.Pins.push(response.Data);
                this.onPinAdded.next(response.Data);
                this.onPinsChanged.next();


                // console.log("new pins", this.Pins);
            }
        )
    }

    ngOnDestroy() {

        this.SubPinsLoaded.unsubscribe();
        this.SubPinDeleted.unsubscribe();
        this.SubPinAdded.unsubscribe();

    }

}
